
import Currencies from './../../../components/monaliza/currency/Currencies';



const Currency = () => {



    return (
    <>
      <Currencies/>
    </>
  )
}

export default Currency